<template>
  <div id="app">
    <v-app id="inspire">
      <v-app id="inspire">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" class="text-center">
              <div class="display-4">404</div>
              <div class="subtitle-1 mb-10">Página não encontrada</div>
              <v-btn @click="$router.go(-1)" small class="white black--text"
                >voltar</v-btn
              >
              <v-btn @click="$router.push('/')" small color="info" class="ml-2"
                >Página Inicial</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-app>
    </v-app>
  </div>
</template>
<script>
export default {
  mounted() {
    // console.log(this.$router);
    // console.log(this.$route.redirectedFrom);
    // console.log(url);
    if (this.$route.redirectedFrom.split("/")[4]) {
      const idbet = this.$route.redirectedFrom.split("/")[4];
      this.$router.push({
        name: this.$permissions().bigTable ? "bigTable" : "Sports",
        query: {
          sport: "Futebol",
          live: "Futebol",
          conf: idbet,
        },
      });
    }
  },
};
</script>
